<template>
  <div class="container">
    <p class="title">{{ title }}</p>
    <div class="table">
      <template v-for="item of tabel">
        <div class="td" :key="item.label">{{ item.label }}</div>
        <div class="td" :class="columnClassName(item)" :key="item.prop">{{ item.value }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    header: Array,
    data: Object,
    title: String,
    columnClassName: {
      type: Function,
      default: () => '',
    },
  },
  computed: {
    tabel() {
      const list = [];
      this.header.forEach(el => {
        const item = { ...el };
        item.value = this.data[el.prop];
        list.push(item);
      });
      return list;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
@table_border: 1px solid #f0f0f0;
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 0 40px;
}
.title {
  font-size: @base-font-size;
  color: @font-color-secondary;
  padding-left: 1em;
}
.table {
  .box_row();
  flex-flow: wrap;
  .td {
    height: 60px;
    border-bottom: @table_border;
    border-right: @table_border;
    .flex_layout(row, flex-start, center);
    box-sizing: border-box;
    padding-left: 1em;
    font-size: @base-font-size;
    &:nth-child(4n + 1) {
      border-left: @table_border;
    }
    &:nth-child(-n + 4) {
      border-top: @table_border;
    }
    &:nth-child(odd) {
      width: 180px;
      background-color: #f8f8f8;
      color: @font-color-secondary;
    }
    &:nth-child(even) {
      width: 280px;
      color: @font-color-black;
    }
  }
}
</style>
